import { Buffer, GL_INTERLEAVED_ATTRIBS, GL_SEPARATE_ATTRIBS } from "./buffer";
let tf = 1;
export class TransformFeedback {
    constructor(synth, props = {}) {
        this.synth = synth;
        this.name = props.name || "transformFeedback_" + tf++;
        this.mode =
            typeof props.mode === "string"
                ? props.mode === "interleaved"
                    ? GL_INTERLEAVED_ATTRIBS
                    : GL_SEPARATE_ATTRIBS
                : props.mode ?? GL_SEPARATE_ATTRIBS;
        this._buffers = {};
        this._buffer = this.synth.renderer.gl.createTransformFeedback();
        this.buffers(props.buffers || {});
    }
    //////////////////////
    clear() {
        // destroy all buffers
        Object.keys(this._buffers).forEach(name => this._buffers[name].clear());
    }
    buffer(name, buffer) {
        this._buffers[name] =
            buffer instanceof Buffer ? buffer : new Buffer(this.synth, { ...buffer, name: this.name + "_" + name });
        return this.bindBuffers();
    }
    buffers(buffers) {
        this._buffers = {};
        const gl = this.synth.renderer.gl;
        for (const [name, attr] of Object.entries(buffers)) {
            if (this._buffers[name])
                gl.deleteBuffer(this._buffers[name]._buffer);
            this._buffers[name] =
                attr instanceof Buffer ? attr : new Buffer(this.synth, { ...attr, name: this.name + "_" + name });
        }
        return this.bindBuffers();
    }
    keys() {
        return Object.keys(this._buffers);
    }
    bindBuffers() {
        const gl = this.synth.renderer.gl;
        gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, this._buffer);
        let bufferBaseIndex = 0;
        for (const [_, b] of Object.entries(this._buffers)) {
            gl.bindBuffer(b._target, b._buffer);
            //gl.bufferData(b._target, b._data as BufferSource, b._usage)
            gl.bindBufferBase(gl.TRANSFORM_FEEDBACK_BUFFER, bufferBaseIndex++, b._buffer);
        }
        gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, null);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
        return this;
    }
}
